import React from "react";
import style from "../styles/contact.module.css";
import {
  AiFillLinkedin,
  AiFillGithub,
  AiOutlineMail,
  AiOutlinePhone,
} from "react-icons/ai";
import { TbMapPin, TbArrowUpRight } from "react-icons/tb";
import { motion } from "framer-motion";
import Reveal from "../components/reveal";
import { profile } from "../data/profile";

const cards = [
  {
    id: "contact-github",
    icon: <AiFillGithub />,
    title: "Github",
    value: profile.github,
    href: profile.githubUrl,
    external: true,
  },
  {
    id: "contact-linkedin",
    icon: <AiFillLinkedin />,
    title: "Linkedin",
    value: profile.linkedin,
    href: profile.linkedinUrl,
    external: true,
  },
  {
    id: "contact-email",
    icon: <AiOutlineMail />,
    title: "E-Mail",
    value: profile.email,
    href: `mailto:${profile.email}`,
  },
  {
    id: "contact-phone",
    icon: <AiOutlinePhone />,
    title: "Phone",
    value: profile.phone,
    href: profile.phoneHref,
  },
  {
    id: "contact-location",
    icon: <TbMapPin />,
    title: "Location",
    value: profile.location,
  },
];

const Contact = () => (
  <section id="contact" className={`sectionShell ${style.contact}`}>
    <div className="sectionInner">
      <Reveal dir="up" amount={0.4}>
        <h2 className="sectionHeading" data-outline="Contact">
          Contact
        </h2>
      </Reveal>

      <Reveal dir="up" delay={0.05}>
        <p className={style.intro}>
          Building something with LLMs or automations?{" "}
          <span className="gradText">Let's talk.</span>
        </p>
      </Reveal>

      <div className={style.grid}>
        {cards.map((card, i) => {
          const inner = (
            <motion.div
              id={card.id}
              className={style.card}
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 280, damping: 22 }}
            >
              <span className={style.icon}>{card.icon}</span>
              <div className={style.desc}>
                <h5>{card.title}</h5>
                <p>{card.value}</p>
              </div>
              {card.href && <TbArrowUpRight className={style.goto} />}
            </motion.div>
          );

          return (
            <Reveal
              dir="up"
              delay={i * 0.07}
              amount={0.2}
              key={card.id}
              className={style.cardWrap}
            >
              {card.href ? (
                <a
                  href={card.href}
                  className={style.cardLink}
                  {...(card.external ? { target: "_blank", rel: "noreferrer" } : {})}
                >
                  {inner}
                </a>
              ) : (
                inner
              )}
            </Reveal>
          );
        })}
      </div>

      <Reveal dir="up" delay={0.1}>
        <a href={`mailto:${profile.email}`} className={style.cta}>
          <AiOutlineMail /> Send me an email
        </a>
      </Reveal>
    </div>
  </section>
);

export default Contact;
